import User from '@/services/user'
import Auth from '@/services/auth'
import Permissions from '@/services/permissions'
import localforage from 'localforage'

const fetch = async ({ commit }) => {
  return new Promise((resolve, reject) => {
    User.fetch().then((response) => {
      commit('SET_LIST', response.data)
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const fetchUser = async (context, id) => {
  return new Promise((resolve, reject) => {
    User.get(id).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const fetchPermissions = async (context, payload) => {
  if (!payload) return

  return new Promise((resolve, reject) => {
    Permissions.fetchByType(payload).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const saveUser = async ({ commit }, payload) => {
  const { verb, user } = payload
  const method = verb === 'put' ? 'update' : 'save'

  return new Promise((resolve, reject) => {
    User[method](user).then((response) => {
      commit('RESET_ERRORS')
      resolve(response.data)
    }).catch((error) => {
      commit('SET_ERRORS', { submit_user: error.response.data })
      reject(error)
    })
  })
}

const saveUserAvatar = async ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    User.saveAvatar(payload).then((response) => {
      commit('RESET_ERRORS')
      resolve(response.data)
    }).catch((error) => {
      commit('SET_ERRORS', { submit_user: error.response.data })
      reject(error)
    })
  })
}

const login = async ({ commit }, payload) => {
  const email = payload.email.trim().toLowerCase()
  const password = payload.password.trim()

  return new Promise((resolve, reject) => {
    Auth.login(email, password).then((response) => {
      const { jwt } = response.data
      localforage.setItem('token', jwt).then((jwt) => {
        commit('SET_TOKEN', jwt, { root: true })
      })
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const redirectLogin = async ({ commit }, token) => {
  return new Promise((resolve, reject) => {
    Auth.redirectLogin(token).then((response) => {
      const data = response.data
      localforage.setItem('token', data[0]['token']).then((jwt) => {
        commit('SET_TOKEN', jwt, { root: true })
      })
      resolve(response.data)
    }).catch((error) => {
      reject(error.response.data)
    })
  })
}

export default {
  fetch,
  fetchUser,
  fetchPermissions,
  saveUser,
  login,
  redirectLogin,
  saveUserAvatar
}



// WEBPACK FOOTER //
// ./src/features/user/store/actions.js